<script>
    export let id;
    export let label;
    export let value = 0;
    // w:55px h:20px
</script>

<div class="switch-with-label">
    <div class="onoffswitch">
        <input
            type="checkbox"
            name="onoffswitch-{id}"
            class="onoffswitch-checkbox"
            {id}
            bind:checked={value}
        />
        <label class="onoffswitch-label" for={id} />
    </div>
    <span class="label">{label}</span>
</div>

<style>
    .switch-with-label {
        height: 24px;
        padding: 5px 0px;
        display: inline-block;
    }
    .onoffswitch {
        display: inline-block;
        position: relative;
        width: 55px;
    }
    .onoffswitch-checkbox {
        position: absolute;
        opacity: 0;
        pointer-events: none;
    }
    .onoffswitch-label {
        display: block;
        overflow: hidden;
        cursor: pointer;
        height: 20px;
        padding: 0;
        line-height: 20px;
        border: 0px solid #ffffff;
        border-radius: 30px;
        background-color: #9e9e9e;
    }
    .onoffswitch-label:before {
        content: "";
        display: block;
        width: 30px;
        margin: -5px;
        background: #ffffff;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 31px;
        border-radius: 30px;
        box-shadow: 0 6px 12px 0px #757575;
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label {
        background-color: #42a5f5;
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label,
    .onoffswitch-checkbox:checked + .onoffswitch-label:before {
        border-color: #42a5f5;
    }

    .onoffswitch-checkbox:checked + .onoffswitch-label:before {
        right: 0px;
        background-color: #2196f3;
        box-shadow: 3px 6px 18px 0px rgba(0, 0, 0, 0.2);
    }
    .onoffswitch-checkbox:focus {
        border: 20px solid orangered;
    }
</style>
